import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface NotificationData {
  message: string;
  type: 'error' | 'info' | 'success' | 'warning';
  tag?: string;
}

export interface FinalizationResult {
  countCode: number;
  success: boolean;
  message?: string;
}

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  private notificationSubject = new Subject<NotificationData>();
  private finalizationResultSubject = new Subject<FinalizationResult>();
  public finalizationResult$ = this.finalizationResultSubject.asObservable();

  private processingCountCodes = new Set<number>();

  public markAsProcessing(countCode: number): void {
    this.processingCountCodes.add(countCode);
  }

  public unmarkAsProcessing(countCode: number): void {
    this.processingCountCodes.delete(countCode);
  }

  public isProcessing(countCode: number): boolean {
    return this.processingCountCodes.has(countCode);
  }

  public emitFinalizationResult(result: FinalizationResult): void {
    this.finalizationResultSubject.next(result);
  }

  private dismissByTagSubject = new Subject<string>();
  public dismissByTag$ = this.dismissByTagSubject.asObservable();

  public dismissByTag(tag: string): void {
    this.dismissByTagSubject.next(tag);
  }

  public showNotification$ = this.notificationSubject.asObservable();

  /**
   * Método principal para disparar a notificação
   */
  public notify(
    message: string,
    type: 'error' | 'info' | 'success' | 'warning' = 'info',
    tag?: string,
  ): void {
    this.notificationSubject.next({ message, type, tag });
  }

  public success(message: string): void {
    this.notify(message, 'success');
  }

  public error(message: string): void {
    this.notify(message, 'error');
  }

  public warning(message: string): void {
    this.notify(message, 'warning');
  }

  public info(message: string, tag?: string): void {
    this.notify(message, 'info', tag);
  }
}
